// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EnrollmentApplications_container__wMRDJ {
  margin: 48px 20px;
  width: 97.2%;
}
.EnrollmentApplications_headerRow__B89Ei {
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;
}
.EnrollmentApplications_headerBox__y5MgN {
  display: flex;
  flex-direction: column;
}
.EnrollmentApplications_backButton__tk783 {
  align-items: center;
  column-gap: 16px;
  cursor: pointer;
  display: flex;
  height: 32px;
  width: fit-content;
}
.EnrollmentApplications_countContainer__o44\\+c {
  display: flex;
  align-items: center;
  justify-content: baseline;
  gap: 32px;
}
.EnrollmentApplications_label__5OaAs {
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  color: #5f6d7e;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 8px;
  padding: 6px 14px;
  border: 1px solid transparent;
  transition:
    background-color 300ms ease-in-out,
    border-color 300ms ease-in-out;
}

.EnrollmentApplications_backButtonArrow__ctZ9q {
  fill: #7e818c;
  transition: fill 200ms ease-in-out;
}
.EnrollmentApplications_backButton__tk783:hover .EnrollmentApplications_backButtonArrow__ctZ9q {
  fill: #cb9c2d;
  transition: fill 200ms ease-in-out;
}
.EnrollmentApplications_backButtonText__tMEvY {
  color: #7e818c;
  font-family: Inter;
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.001em;
  margin: 0px;
  text-transform: capitalize;
  transition: color 200ms ease-in-out;
}
.EnrollmentApplications_backButton__tk783:hover .EnrollmentApplications_backButtonText__tMEvY {
  color: #cb9c2d;
  transition: color 200ms ease-in-out;
}
.EnrollmentApplications_heading__pK1N9 {
  color: #4d4d4d;
  cursor: default;
  font-family: Inter;
  font-size: 40px;
  font-weight: 600;
  line-height: 48px;
  letter-spacing: -0.001em;
  margin: 0px;
  text-align: left;
}
.EnrollmentApplications_searchInputContainer__yKNMg {
  margin-bottom: 48px;
}
.EnrollmentApplications_searchInput__ptXNV {
  border: 1px solid #d9dce0;
  width: 438px;
  height: 46px;
  padding: 8px 16px 8px 46px;
  border-radius: 8px;
}
.EnrollmentApplications_searchInput__ptXNV::placeholder {
  color: rgba(95, 109, 126, 0.6);
  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.001em;
}
.EnrollmentApplications_searchInput__ptXNV:focus {
  border: 1px solid rgba(203, 156, 45, 1);
  outline: none;
}
.EnrollmentApplications_searchIcon__IwVQF {
  height: 24px;
  margin: 10px 16px 0px;
  position: absolute;
  width: 24px;
}
.EnrollmentApplications_selectContainer__KmQx2 {
  margin: 48px 0px 32px;
  width: 438px;
  height: 42px;
  box-sizing: border-box;
}

.EnrollmentApplications_select__24zZ5 {
  width: 100%;
  box-sizing: border-box;
  height: 100%;
  padding: 0 15px;
  border: 1px solid #d8dbdf;
  border-radius: 8px;
  box-shadow: 0px 0px 30px 5px rgba(95, 109, 126, 0.1);
  font-size: 15px;
  font-family: "Inter";
  font-weight: 400;
  line-height: 22px;
  color: #5f6d7e;
}

.EnrollmentApplications_select__24zZ5:focus {
  outline: none;
}

.EnrollmentApplications_flexContainer__CY-G3 {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: center;
  gap: 30px;
}

.EnrollmentApplications_searchContainer__1ttiq {
  height: 26px;
  box-sizing: border-box;
  box-shadow: 0px 0px 30px 5px rgba(95, 109, 126, 0.1);
  border-radius: 8px;
}
.EnrollmentApplications_searchInputRef__k5QUg {
  height: 80%;
  padding: 10px 20px;
  font-size: 14px;
  font-family: "Inter";
  font-weight: 400;
  color: #5f6d7e;
}

.EnrollmentApplications_noGroupsWrapper__oaf71 {
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
}
.EnrollmentApplications_noGroupsWrapper__oaf71 {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 16px;
  background-color: #ffebeb;
  padding: 12px 24px;
  width: 100%;
  color: #5f6d7e;
  font-size: 14px;
  line-height: normal;
  border-radius: 6px;
}
.EnrollmentApplications_noGroupsIcon__n2aCR {
  width: 16px;
  height: 16px;
}

@media screen and (max-width: 500px) {
  .EnrollmentApplications_selectContainer__KmQx2 {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/scenes/documents/components/enrollmentApplications/EnrollmentApplications.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B;;kCAEgC;AAClC;;AAEA;EACE,aAAa;EACb,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,kCAAkC;AACpC;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;EACX,0BAA0B;EAC1B,mCAAmC;AACrC;AACA;EACE,cAAc;EACd,mCAAmC;AACrC;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,uCAAuC;EACvC,aAAa;AACf;AACA;EACE,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,oDAAoD;EACpD,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,oDAAoD;EACpD,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,WAAW;EACb;AACF","sourcesContent":[".container {\n  margin: 48px 20px;\n  width: 97.2%;\n}\n.headerRow {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 40px;\n}\n.headerBox {\n  display: flex;\n  flex-direction: column;\n}\n.backButton {\n  align-items: center;\n  column-gap: 16px;\n  cursor: pointer;\n  display: flex;\n  height: 32px;\n  width: fit-content;\n}\n.countContainer {\n  display: flex;\n  align-items: center;\n  justify-content: baseline;\n  gap: 32px;\n}\n.label {\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  color: #5f6d7e;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  border-radius: 8px;\n  padding: 6px 14px;\n  border: 1px solid transparent;\n  transition:\n    background-color 300ms ease-in-out,\n    border-color 300ms ease-in-out;\n}\n\n.backButtonArrow {\n  fill: #7e818c;\n  transition: fill 200ms ease-in-out;\n}\n.backButton:hover .backButtonArrow {\n  fill: #cb9c2d;\n  transition: fill 200ms ease-in-out;\n}\n.backButtonText {\n  color: #7e818c;\n  font-family: Inter;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 24px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n  text-transform: capitalize;\n  transition: color 200ms ease-in-out;\n}\n.backButton:hover .backButtonText {\n  color: #cb9c2d;\n  transition: color 200ms ease-in-out;\n}\n.heading {\n  color: #4d4d4d;\n  cursor: default;\n  font-family: Inter;\n  font-size: 40px;\n  font-weight: 600;\n  line-height: 48px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n  text-align: left;\n}\n.searchInputContainer {\n  margin-bottom: 48px;\n}\n.searchInput {\n  border: 1px solid #d9dce0;\n  width: 438px;\n  height: 46px;\n  padding: 8px 16px 8px 46px;\n  border-radius: 8px;\n}\n.searchInput::placeholder {\n  color: rgba(95, 109, 126, 0.6);\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n}\n.searchInput:focus {\n  border: 1px solid rgba(203, 156, 45, 1);\n  outline: none;\n}\n.searchIcon {\n  height: 24px;\n  margin: 10px 16px 0px;\n  position: absolute;\n  width: 24px;\n}\n.selectContainer {\n  margin: 48px 0px 32px;\n  width: 438px;\n  height: 42px;\n  box-sizing: border-box;\n}\n\n.select {\n  width: 100%;\n  box-sizing: border-box;\n  height: 100%;\n  padding: 0 15px;\n  border: 1px solid #d8dbdf;\n  border-radius: 8px;\n  box-shadow: 0px 0px 30px 5px rgba(95, 109, 126, 0.1);\n  font-size: 15px;\n  font-family: \"Inter\";\n  font-weight: 400;\n  line-height: 22px;\n  color: #5f6d7e;\n}\n\n.select:focus {\n  outline: none;\n}\n\n.flexContainer {\n  display: flex;\n  flex-direction: row-reverse;\n  align-items: center;\n  justify-content: center;\n  gap: 30px;\n}\n\n.searchContainer {\n  height: 26px;\n  box-sizing: border-box;\n  box-shadow: 0px 0px 30px 5px rgba(95, 109, 126, 0.1);\n  border-radius: 8px;\n}\n.searchInputRef {\n  height: 80%;\n  padding: 10px 20px;\n  font-size: 14px;\n  font-family: \"Inter\";\n  font-weight: 400;\n  color: #5f6d7e;\n}\n\n.noGroupsWrapper {\n  font-family: Inter;\n  font-style: normal;\n  font-weight: 500;\n}\n.noGroupsWrapper {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  gap: 16px;\n  background-color: #ffebeb;\n  padding: 12px 24px;\n  width: 100%;\n  color: #5f6d7e;\n  font-size: 14px;\n  line-height: normal;\n  border-radius: 6px;\n}\n.noGroupsIcon {\n  width: 16px;\n  height: 16px;\n}\n\n@media screen and (max-width: 500px) {\n  .selectContainer {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `EnrollmentApplications_container__wMRDJ`,
	"headerRow": `EnrollmentApplications_headerRow__B89Ei`,
	"headerBox": `EnrollmentApplications_headerBox__y5MgN`,
	"backButton": `EnrollmentApplications_backButton__tk783`,
	"countContainer": `EnrollmentApplications_countContainer__o44+c`,
	"label": `EnrollmentApplications_label__5OaAs`,
	"backButtonArrow": `EnrollmentApplications_backButtonArrow__ctZ9q`,
	"backButtonText": `EnrollmentApplications_backButtonText__tMEvY`,
	"heading": `EnrollmentApplications_heading__pK1N9`,
	"searchInputContainer": `EnrollmentApplications_searchInputContainer__yKNMg`,
	"searchInput": `EnrollmentApplications_searchInput__ptXNV`,
	"searchIcon": `EnrollmentApplications_searchIcon__IwVQF`,
	"selectContainer": `EnrollmentApplications_selectContainer__KmQx2`,
	"select": `EnrollmentApplications_select__24zZ5`,
	"flexContainer": `EnrollmentApplications_flexContainer__CY-G3`,
	"searchContainer": `EnrollmentApplications_searchContainer__1ttiq`,
	"searchInputRef": `EnrollmentApplications_searchInputRef__k5QUg`,
	"noGroupsWrapper": `EnrollmentApplications_noGroupsWrapper__oaf71`,
	"noGroupsIcon": `EnrollmentApplications_noGroupsIcon__n2aCR`
};
export default ___CSS_LOADER_EXPORT___;
